import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

const PlusPlanCard = ({children}) => {
	return (
		<div className="plus-plan-card">
			{children}
		</div>
	);
};

PlusPlanCard.propTypes = {
	children: PropTypes.node
}

export default PlusPlanCard;
